import { debounce } from '../utils/_debounce'
import Swiper from 'swiper/bundle'

export default class Employees {
  constructor () {
    setTimeout(() => this.initEmployeeAnimation(), 100)

    if (document.querySelector('.mtt-employees .swiper-container')) {
      this.swiperHandler()
    }
  }

  initEmployeeAnimation () {
    const EMPLOYEES = document.querySelectorAll('.employee-card')
    if (EMPLOYEES.length > 0) {
      for (let i = 0; i < EMPLOYEES.length; i++) {
        const animation = new EmployeeAnimation(EMPLOYEES[i])
      }
    }
  }

  swiperHandler () {
    let swiper = this.createSwiper()
    let init = false

    if (this.getScreenWidth() <= 850) {
      swiper.init()
      init = true
    }

    window.addEventListener('resize', debounce(() => {
      if (this.getScreenWidth() <= 850) {
        if (init) return
        swiper = this.createSwiper()
        swiper.init()
        init = true
      } else {
        if (!init) return
        swiper.destroy()
        init = false
      }
    }, 300))
  }

  createSwiper () {
    return new Swiper('.mtt-employees .swiper-container', {
      init: false,
      slidesPerView: 1.1,
      speed: 800,
      spaceBetween: 24,
      freeMode: true,
      watchOverflow: true,
      preloadImages: false,
      lazy: true,
      breakpoints: {
        351: {
          slidesPerView: 1.2
        },
        501: {
          slidesPerView: 1.6
        },
        581: {
          slidesPerView: 2
        },
        701: {
          slidesPerView: 2.3
        }
      }
    })
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}

class EmployeeAnimation {
  constructor (EMPLOYEE) {
    this.EMPLOYEE = EMPLOYEE

    this.HIDDEN_INFO = this.EMPLOYEE.querySelector('.employee-card__hidden-info')
    this.TEXT_CONTAINER = this.EMPLOYEE.querySelector('.employee-card__text-container')
    if (!this.HIDDEN_INFO || !this.TEXT_CONTAINER) return

    // calculate heights
    this.calcHeights()
    window.addEventListener('resize', debounce(() => this.calcHeights(), 300))

    // setup height and translateY
    this.TEXT_CONTAINER.style.height = this.newHeight + 'px'
    this.TEXT_CONTAINER.style.transform = `translateY(${this.infoHeight}px)`
    setTimeout(() => this.TEXT_CONTAINER.classList.add('transition'), 300)

    // events
    this.EMPLOYEE.addEventListener('mouseenter', () => this.getScreenWidth() > 1160 && this.hoverEnter())
    this.EMPLOYEE.addEventListener('mouseleave', () => this.getScreenWidth() > 1160 && this.hoverLeave())
    this.EMPLOYEE.addEventListener('click', () => {
      if (this.getScreenWidth() > 1160) return
      (this.EMPLOYEE.className.indexOf('hovering') === -1) ? this.hoverEnter() : this.hoverLeave()
    })
  }

  // calculate heights
  calcHeights () {
    this.infoHeight = this.HIDDEN_INFO.getBoundingClientRect().height
    this.textContainerHeight = this.TEXT_CONTAINER.getBoundingClientRect().height
    this.newHeight = this.textContainerHeight + this.infoHeight
  }

  hoverEnter () {
    this.EMPLOYEE.classList.add('hovering')
    this.TEXT_CONTAINER.style.transform = 'translateY(0px)'
    this.HIDDEN_INFO.style.opacity = '1'
  }

  hoverLeave () {
    this.EMPLOYEE.classList.remove('hovering')
    this.TEXT_CONTAINER.style.transform = `translateY(${this.infoHeight}px)`
    this.HIDDEN_INFO.style.opacity = '0'
  }

  getScreenWidth () {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  }
}
